import { all, put, call, takeEvery } from 'redux-saga/effects'
import {getLoginUserType } from 'services/menu'
import _ from 'underscore'
import dataConstant from 'constants/dataConstants';
import actions from './actions'

export function* GET_DATA() {

  let menuTopData = JSON.parse(localStorage.getItem('menuTopData'))
  const userData = JSON.parse(localStorage.getItem('webappuser'))

  const LoginstateData = yield call(getLoginUserType)
   let MaterialTypeList = []
    const childrensList = []
  if(LoginstateData && LoginstateData.MaterialType)
  {
    MaterialTypeList = LoginstateData.MaterialType.split(',')
  }
 
  if (LoginstateData != null) { 
    if(menuTopData && menuTopData.length > 0){
      // Exclude sub-menus which are not type of login RefType.
      _.each(menuTopData,(i) => {
        if(i && i.key === "inward" && i.children && i.children.length > 0) { 
         if(userData && userData.RefType === dataConstant.RefType.Supplier){
          _.each(MaterialTypeList,(MaterialType) => {
            const childrensData = _.find(i.children, (c) => { return c.key === MaterialType.trim() })
            childrensList.push(childrensData)
          })
          i.children = childrensList
        }             
        //  if(LoginstateData.MaterialType && LoginstateData.MaterialType !== dataConstant.InwardCategory.Both){
        //   i.children = _.reject(i.children,(c) => {
        //     return  c.key !== LoginstateData.MaterialType;     
        //   });
        // }
      }
     })
     yield put({
      type: 'menu/SET_STATE',
      payload: {
        menuTopData,
      },
    })
    }
  } else {
    menuTopData = []// yield call(getTopMenuData)
  }
}


export default function* rootSaga() {
     yield all([
       takeEvery(actions.GET_DATA,GET_DATA),
       GET_DATA()
        // run once on app load to fetch menu data
     ])
}
